/* ==========================================================================
   DIIP BLOG LIST — Load More + กรองหมวดหมู่ (ฝั่ง Client ไม่เปลี่ยน URL)

   ปุ่ม "ดูเพิ่มเติม": ดึงหน้าถัดไปมาต่อท้าย Grid เดิมโดยไม่ต้องรีเฟรชหน้า
   ปุ่มหมวดหมู่: ซ่อน/โชว์การ์ดตาม Tag (data-tags ของการ์ด เทียบกับ data-category-tag ของปุ่ม)
   ทำงานได้ทั้งกรณีปกติ (blog.articles) และกรณีค้นหา (search.results)

   DIIP RESTRUCTURE — สิ่งที่แก้จากเวอร์ชันก่อน:
   1) กดหมวดหมู่แล้วโหลดหน้าที่เหลือให้ครบอัตโนมัติ (เดิมกรองได้เฉพาะการ์ดที่โหลดมาแล้ว บทความใน Tag
      เดียวกันที่อยู่หน้าถัดไปจึงหายไปเฉยๆ ดูเหมือนบั๊ก)
   2) ข้อความ "กำลังโหลด..."/"โหลดไม่สำเร็จ" อ่านจาก data-attribute ที่ Liquid ส่งมา (แปลภาษาได้) ไม่ฝังภาษาไทยใน JS
   3) ข้อความ "โหลดไม่สำเร็จ" เดิมถูกเขียนทับทันทีด้วยข้อความปุ่มเดิม จึงไม่เคยเห็นเลย — ตอนนี้โชว์ค้างไว้ 3 วินาที
   4) ?tag=xxx ไม่สร้าง CSS Selector จากค่าใน URL แล้ว (เดิมถ้าค่ามีเครื่องหมายคำพูด Selector พัง JS หยุดทำงาน)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var grid = document.getElementById('diip-blog-grid');
  if (!grid) return;

  var loadMoreBtn = document.querySelector('[data-load-more]');
  var filterGroup = document.querySelector('[data-tag-filter-group]');
  var activeTag = '__all__';
  var loadingAll = null;      // Promise ระหว่างกำลังโหลดหน้าที่เหลือให้ครบ (กันโหลดซ้อน)
  var MAX_PAGES = 50;         // เพดานกันวนไม่รู้จบ ถ้า Server คืนหน้าเดิมซ้ำ

  function nextUrl() {
    return loadMoreBtn ? loadMoreBtn.getAttribute('data-next-url') : null;
  }

  function hideLoadMore() {
    if (!loadMoreBtn) return;
    loadMoreBtn.removeAttribute('data-next-url');
    loadMoreBtn.style.display = 'none';
  }

  /* ดึง 1 หน้า ต่อการ์ดท้าย Grid แล้วอัปเดต URL หน้าถัดไป — คืน Promise<true> ถ้าเพิ่มการ์ดได้ */
  function fetchNextPage() {
    var url = nextUrl();
    if (!url) return Promise.resolve(false);

    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Load more failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('diip-blog-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (card) {
            grid.appendChild(card);
          });
        }

        var nextBtn = doc.querySelector('[data-load-more]');
        var upcoming = nextBtn ? nextBtn.getAttribute('data-next-url') : null;
        if (upcoming && upcoming !== url) {
          loadMoreBtn.setAttribute('data-next-url', upcoming);
        } else {
          hideLoadMore(); // ไม่มีหน้าถัดไปแล้ว (หรือ URL ซ้ำกับที่เพิ่งโหลด กันวนซ้ำ)
        }
        return true;
      });
  }

  /* ---------- ปุ่ม "ดูเพิ่มเติม" ---------- */
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      if (loadMoreBtn.disabled || loadingAll) return;

      var originalText = loadMoreBtn.textContent;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-loading-text') || originalText;

      fetchNextPage()
        .then(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = originalText;
        })
        .catch(function () {
          // โชว์ข้อความ error ค้างไว้ให้เห็นก่อน แล้วค่อยคืนข้อความเดิม
          loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-error-text') || originalText;
          setTimeout(function () {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = originalText;
          }, 3000);
        });
    });
  }

  /* ---------- กรองหมวดหมู่ ---------- */
  if (!filterGroup) return;

  var tabButtons = Array.prototype.slice.call(filterGroup.querySelectorAll('[data-category-tag]'));

  function applyFilter() {
    var cards = grid.querySelectorAll('.diip-blog-card');
    Array.prototype.forEach.call(cards, function (card) {
      if (activeTag === '__all__') {
        card.style.display = '';
        return;
      }
      var cardTags = (card.getAttribute('data-tags') || '').split(',');
      card.style.display = cardTags.indexOf(activeTag) !== -1 ? '' : 'none';
    });
  }

  function setBusy(isBusy) {
    filterGroup.classList.toggle('is-loading', isBusy);
    if (loadMoreBtn) loadMoreBtn.disabled = isBusy;
  }

  /* โหลดหน้าที่เหลือให้ครบ เพื่อให้กรองเจอบทความของ Tag นั้นครบทุกบทความ ไม่ใช่เฉพาะหน้าแรก */
  function loadAllRemaining() {
    if (loadingAll) return loadingAll;
    if (!nextUrl()) return Promise.resolve();

    setBusy(true);
    var pages = 0;

    function step() {
      if (!nextUrl() || pages >= MAX_PAGES) return Promise.resolve();
      pages += 1;
      return fetchNextPage().then(function (added) {
        return added ? step() : null;
      });
    }

    loadingAll = step()
      .catch(function () {
        // โหลดไม่ครบก็ไม่เป็นไร กรองเท่าที่มีได้ และปุ่ม "ดูเพิ่มเติม" ยังกดเองต่อได้
      })
      .then(function () {
        loadingAll = null;
        setBusy(false);
        applyFilter();
      });

    return loadingAll;
  }

  function selectTab(btn) {
    activeTag = btn.getAttribute('data-category-tag');
    tabButtons.forEach(function (b) {
      var isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    applyFilter();                       // กรองการ์ดที่มีอยู่ทันที (ตอบสนองเร็ว)
    if (activeTag !== '__all__') loadAllRemaining(); // แล้วโหลดหน้าที่เหลือมากรองต่อให้ครบ
  }

  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { selectTab(btn); });
  });

  // การ์ดใหม่ที่ต่อท้ายเข้ามา (จาก Load More หรือโหลดอัตโนมัติ) ต้องถูกกรองตามหมวดที่เลือกอยู่ด้วย
  new MutationObserver(applyFilter).observe(grid, { childList: true });

  /* ลิงก์แชร์ ?tag=xxx — เทียบค่าโดยวนเช็คปุ่ม ไม่สร้าง CSS Selector จากค่าใน URL (ปลอดภัยกับอักขระแปลกๆ) */
  var initialTag = (new URLSearchParams(window.location.search).get('tag') || '').trim().toLowerCase();
  if (initialTag) {
    for (var i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i].getAttribute('data-category-tag') === initialTag) {
        selectTab(tabButtons[i]);
        break;
      }
    }
  }
});
